import { render } from "./GamesPage.vue?vue&type=template&id=057ba526&scoped=true"
const script = {}

import "./GamesPage.vue?vue&type=style&index=0&id=057ba526&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057ba526"]])

export default __exports__